// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"9314203a","450":"97d724d9","668":"15692760"}[chunkId] + ".chunk.js";
};